import React from 'react';
// import { Link } from 'react-router';
import ReactLoading from 'react-loading';
import { connect } from 'react-redux';
// import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../actions/appointmentActions.js';
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
// import $ from "jquery";
// import '../../styles/css/style.css';

class BookingConfirmation extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			isLoader: true,
			isConfirm: false,
			appointmentDetails: {}
		}
	}
	componentWillMount() {
		this.setState({ isLoader: false })
		let appointmentObj = {
			appointmentId: localStorage.getItem('appointmentId'),
			bookingConfirm: true
		}
		this.props.actions.getAppointmentDetails(appointmentObj);

	}
	componentDidMount() {
	}
	componentWillReceiveProps(nextProps) {
		this.setState({
			appointmentDetails: nextProps.appointmentDetails
		})
	}

	onChange(event) {
		// const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
		this.setState({
			[event.target.name]: event.target.checked
		});
	}

	render() {
		var appointmentDetails = this.state.appointmentDetails;
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		return (
			<div className="content-wrapper">
			<ToastContainer />
				{this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> :
					<section className="content container-fluid ">
						{/* <div className="row searchSub">
							<div className="col-md-5">
								<div className="boxMrgB">
									<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img//family_medicine.png')} alt="" /></i></span>
										<input type="" className="form-control" placeholder="Family Medicine" />
									</div>
								</div>
							</div>
							<div className="col-md-5">
								<div className="boxMrgB">
									<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img//map_icon.png')} alt="" /></i></span>
										<input type="" className="form-control" placeholder="Family Medicine" />
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="boxMrgB">
									<button type="button" className="btn btn-block btn-warning btn-lg">Search</button>
								</div>
							</div>
						</div> */}
						<div className="row">
							<div className="col-md-12">
								<div className="row">
									<div className="col-xs-12 col-sm-8 col-md-8 col-lg-8 m-0-auto">
										<div className="tabRadi text-center">
											<div className="padtb">
												<img src={require('../../images/img/circleImg.png')} alt="Thank you" />
											</div>
											<h3>Thank You for your booking!</h3>
											<p>Dr. <span className="text-capitalize">{appointmentDetails ? appointmentDetails.users ? appointmentDetails.users[0].userName : '' : ''}</span> will look forward to meeting you.</p>
											<div className="boxOnline">
												{appointmentDetails ? appointmentDetails.appointmentMode == '1' ? <img src={require('../../images/img/face.png')} alt="Face to Face" /> : <img src={require('../../images/img/online.png')} alt="Online" /> : ''}
												<h3>{appointmentDetails ? appointmentDetails.appointmentMode == '1' ? 'Face to face' : 'Online' : ''}</h3>
												<h4> {appointmentDetails ? moment.parseZone(new Date(appointmentDetails.checkappointmentDate)).format('DD-MM-YYYY') : ''},  {appointmentDetails ? moment.parseZone(new Date(appointmentDetails.checkappointmentDate)).format('hh:mm A') + " " + userlocation : ''} </h4>
											</div>
											<div className="confmsg">
												Confirmation email will be sent to your registered email address
                  </div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>}

				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		appointmentDetails: state.appointment.appointmentDetails
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(BookingConfirmation);